// AbReportsFlag — Flaggen-Icon im Header (Vorbild OC-Pilot components/MyReportsBell.tsx),
// oeffnet AbMyReports. Badge = Anzahl der EIGENEN offenen Meldungen (resolved === false).
// Pollt alle 60s + einmal beim Wechsel des aktiven Sub-Views (faengt frisch gemeldete/geloeste
// Dokumente ein, z. B. direkt nach "Melden" in AbDocumentDetail).

import React, { useCallback, useEffect } from 'react';
import { Flag } from 'lucide-react';
import { HeaderIconButton } from '../ui';
import { listMyReports } from '../../api';

const POLL_MS = 60000;

const AbReportsFlag = ({ user, isDarkMode, t, active, onOpen, refreshKey }) => {
  const [openCount, setOpenCount] = React.useState(0);

  const refresh = useCallback(() => {
    listMyReports(user)
      .then((rows) => setOpenCount(Array.isArray(rows) ? rows.filter((r) => !r.resolved).length : 0))
      .catch(() => {});
  }, [user]);

  useEffect(() => { refresh(); }, [refresh, refreshKey]);
  useEffect(() => {
    const id = setInterval(refresh, POLL_MS);
    return () => clearInterval(id);
  }, [refresh]);

  return (
    <HeaderIconButton
      isDarkMode={isDarkMode}
      onClick={onOpen}
      active={active}
      badge={openCount}
      title={t('ab.shell.myReportsTitle')}
      ariaLabel={t('ab.shell.myReportsAriaLabel', { n: openCount })}
    >
      <Flag className="w-4 h-4" />
    </HeaderIconButton>
  );
};

export default AbReportsFlag;
